import { Commanding } from '@/backend/models/commanding';
import { CommandingRun } from '@/backend/models/commandingRun';
import { resize } from '@/frontend/utils/parseReferences';
import { I18n } from '@/i18n/I18n';
import { useEffect } from 'react';

export function CommandingDebugger(props: {
  commandingRun?: CommandingRun,
  commanding: Commanding
}) {
  const { commandingRun, commanding } = props;

  const inputTasks = commandingRun?.inputTasks || commanding.inputTasks;
  const outputTasks = commandingRun?.outputTasks || commanding.outputTasks;

  function resizeItems() {
    const inputsToResize = [
      `commanding-run-input-tasks${commanding.id}`,
      `commanding-run-output-tasks${commanding.id}`,
      `commanding-run-rendered-input-tasks${commanding.id}`,
      `commanding-run-rendered-output-tasks${commanding.id}`,
      `commanding-run-input-task-responses${commanding.id}`,
      `commanding-run-output-task-responses${commanding.id}`
    ];
    inputsToResize.forEach((input) => {
      resize(input);
    });
  }

  useEffect(() => {
    resizeItems();
  }, [commandingRun]);

  return (
    <div>
      <div className="row mt-2">
        <div className="col-6">
          <div className="form-floating">
            <textarea
              className="form-control form-control-sm font-monospace"
              id={`commanding-run-input-tasks${commanding.id}`}
              disabled
              value={inputTasks}
            />
            <label htmlFor={`commanding-run-input-tasks${commanding.id}`}>{I18n.get('rawInputTasks')}</label>
          </div>
        </div>
        <div className="col-6">
          <div className="form-floating">
            <textarea
              className="form-control form-control-sm font-monospace"
              id={`commanding-run-output-tasks${commanding.id}`}
              disabled
              value={outputTasks}
            />
            <label htmlFor={`commanding-run-output-tasks${commanding.id}`}>{I18n.get('rawOutputTasks')}</label>
          </div>
        </div>
      </div>
      {commandingRun &&
        <>
          <div className="row mt-2">
            <div className="col-6">
              <div className="form-floating">
                <textarea
                  className="form-control form-control-sm font-monospace"
                  id={`commanding-run-rendered-input-tasks${commandingRun.id}`}
                  disabled
                  value={commandingRun.renderedInputTasks}
                />
                <label htmlFor={`commanding-run-rendered-input-tasks${commandingRun.id}`}>{I18n.get('renderedInputTasks')}</label>
              </div>
            </div>
            <div className="col-6">
              <div className="form-floating">
                <textarea
                  className="form-control form-control-sm font-monospace"
                  id={`commanding-run-rendered-output-tasks${commandingRun.id}`}
                  disabled
                  value={commandingRun.renderedOutputTasks}
                />
                <label htmlFor={`commanding-run-rendered-output-tasks${commandingRun.id}`}>{I18n.get('renderedOutputTasks')}</label>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">
              <div className="form-floating">
                <textarea
                  className="form-control form-control-sm font-monospace"
                  id={`commanding-run-input-task-responses${commandingRun.id}`}
                  disabled
                  value={commandingRun.inputTaskResponses}
                />
                <label htmlFor={`commanding-run-input-task-responses${commandingRun.id}`}>{I18n.get('inputTaskResponses')}</label>
              </div>
            </div>
            <div className="col-6">
              <div className="form-floating">
                <textarea
                  className="form-control form-control-sm font-monospace"
                  id={`commanding-run-output-task-responses${commandingRun.id}`}
                  disabled
                  value={commandingRun.outputTaskResponses}
                />
                <label htmlFor={`commanding-run-output-task-responses${commandingRun.id}`}>{I18n.get('outputTaskResponses')}</label>
              </div>
            </div>
          </div>
        </>
      }
    </div>
  );
}
